import Swiper from 'swiper'
import { Autoplay } from 'swiper/modules'

document.addEventListener('DOMContentLoaded', () => {
  const logoLines = document.querySelectorAll('.mt-logo-line')
  if (logoLines.length > 0) {
    logoLines.forEach((logoLine) => new LogoLine(logoLine))
  }
})

class LogoLine {
  constructor (logoLine) {
    this.logoLine = logoLine

    if (this.logoLine) {
      this.addSwiper()
    }
  }

  addSwiper() {
    const SWIPER_ELEMENT = this.logoLine.querySelector('.swiper');
    const SWIPER_WRAPPER = this.logoLine.querySelector('.swiper-wrapper');
    const SWIPER_SLIDES = this.logoLine.querySelectorAll('.swiper-slide');

    if (!SWIPER_ELEMENT) {
      return;
    }

    const shouldSlide = this.logoLine.classList.contains('mt-logo-line--should-slide');
    const totalSlides = SWIPER_SLIDES.length;

    const swiperOptions = {
      modules: [Autoplay],
      loop: true,
      allowTouchMove: false,
      spaceBetween: 32,
      slidesPerView: 3,
      breakpoints: {
        801: {
          slidesPerView: 4,
        },
        1537: {
          slidesPerView: 5,
        },
      },
    };

    if (shouldSlide && totalSlides < 10) {
      const slidesToDuplicate = 10 - totalSlides;

      // Duplicate slides if necessary
      for (let i = 0; i < slidesToDuplicate; i++) {
        if (SWIPER_WRAPPER.childElementCount >= 10) {
          break; // Break out of the loop if the total slides reach or exceed 10
        }

        SWIPER_SLIDES.forEach((slide) => {
          const clonedSlide = slide.cloneNode(true);
          SWIPER_WRAPPER.appendChild(clonedSlide);
        });
      }
    }

    // Conditionally add autoplay options if shouldSlide is true
    if (shouldSlide) {
      swiperOptions.autoplay = {
        delay: 0, // Set delay to 0 for immediate autoplay
        disableOnInteraction: false,
      };
      swiperOptions.speed = 6000;
    }

    // Initialize Swiper
    this.swiper = new Swiper(SWIPER_ELEMENT, swiperOptions);
  }

}
